import React, { useState, useEffect } from "react";

const Typewriter = ({ texts, typingSpeed = 100, eraseSpeed = 50, delay = 1000 }) => {
    const [currentText, setCurrentText] = useState("");
    const [isDeleting, setIsDeleting] = useState(false);
    const [textIndex, setTextIndex] = useState(0);
    const [charIndex, setCharIndex] = useState(0);

    useEffect(() => {
        const handleTyping = () => {
            const currentString = texts[textIndex];
            if (!isDeleting) {
                // Typing effect
                
                if (charIndex < currentString.length) {
                    setCurrentText((prev) => prev + currentString.charAt(charIndex));
                    setCharIndex((prev) => prev + 1);
                } else {
                    // Start deleting after delay
                    setTimeout(() => setIsDeleting(true), delay);
                }
            } else {
                // Erasing effect
                if (charIndex > 0) {
                    setCurrentText(currentString.substring(0, charIndex - 1));
                    setCharIndex((prev) => prev - 1);
                } else {
                    // Move to the next text
                    setIsDeleting(false);
                    setTextIndex((prev) => (prev + 1) % texts.length);
                }
            }
        };

        const typingSpeedInterval = isDeleting ? eraseSpeed : typingSpeed;
        const typingTimeout = setTimeout(handleTyping, typingSpeedInterval);

        return () => clearTimeout(typingTimeout);
    }, [charIndex, isDeleting, texts, textIndex, delay, typingSpeed, eraseSpeed]);

    return (
        <span style={{ borderRight: "2px solid", whiteSpace: "nowrap" }}>
            {currentText}
        </span>
    );
};

export default Typewriter;